import {
  IAccountRepository,
  UpdatePasswordRegisterResult,
} from "../../../domain/account";
import { AuthenticatedService } from "../../AuthenticatedService";
import {
  IUpdatePasswordRegisterRequestBean,
  IUpdatePasswordRegisterResultBean,
} from "./beans";

export class AccountRepository extends AuthenticatedService implements IAccountRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async updatePassword(currentPassword: string, newPassword: string): Promise<UpdatePasswordRegisterResult> {
    const url = "/api/account/update-password";
    const request: IUpdatePasswordRegisterRequestBean = {
      currentPassword: currentPassword,
      newPassword: newPassword,
    };
    const result = await this.post(url, request);
    return this.toUpdatePasswordRegisterResult(result.data);
  }

  private toUpdatePasswordRegisterResult(bean: IUpdatePasswordRegisterResultBean): UpdatePasswordRegisterResult {
    if (!bean) { throw new Error("bean is empty!!!"); }

    const result = new UpdatePasswordRegisterResult();
    result.isOk = !!bean.isOk;
    result.isCurrentPasswordInvalid = !!bean.isCurrentPasswordInvalid;
    return result;
  }

  async deleteAccount(): Promise<void> {
    const url = "/api/account/delete";
    await this.post(url);
  }
}
